/**
 * The iframe-URL's fragment is used to pass data on (e.g. #param1=value1&param2=value2)
 * where the values are encoded using encodeURIComponent.
 * This function will return the key-value pairs as an object.
 * @returns {{}|undefined}
 */
// eslint-disable-next-line import/prefer-default-export
export const getUrlHashParams = () => {
  const hash = window.location.hash.substring(1);

  if (hash === '') {
    return undefined;
  }

  return hash.split('&').reduce((aggregatedParameters, item) => {
    const [key, value] = item.split('=');
    return {
      ...aggregatedParameters,
      [key]: decodeURIComponent(value),
    };
  }, {});
};
